import ProductConfiguration from './ProductConfiguration.container';

export default ProductConfiguration;
